/**
 * Language helpers. The active language is owned by BrzFrame (see AppFrame), not detected here.
 *
 * @category Utils
 * @group Language
 */

/**
 * Supported languages in the application
 */
export const SUPPORTED_LANGUAGES = ['de', 'en'] as const;
type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * Default language fallback
 */
export const DEFAULT_LANGUAGE: SupportedLanguage = 'de';

/**
 * Validates if a language code is supported
 *
 * @param {string} language - Language code to validate
 * @returns {boolean} True if language is supported
 */
export function isSupportedLanguage(language: string): language is SupportedLanguage {
  return SUPPORTED_LANGUAGES.includes(language as SupportedLanguage);
}

/**
 * Maps language codes to supported languages
 * Handles regional variants (e.g., en-US, en-GB -> en)
 *
 * @param {string} browserLanguage - Language code
 * @returns {SupportedLanguage} Mapped supported language
 */
export function mapBrowserLanguageToSupported(browserLanguage: string): SupportedLanguage {
  const langCode = browserLanguage.split('-')[0].toLowerCase();
  return isSupportedLanguage(langCode) ? langCode : DEFAULT_LANGUAGE;
}
